import m from "mithril";
import SearchFormComponent from "../../mobile/hotelsearch/SearchFormComponent";
import MessageProvider from "../../../MessageProvider";
import {CalendarDialog, Dialog} from '../../common/MaterialDesignComponents';
import { Location } from "../../../Models";
import HotelSearchFormState from "../../../states/HotelSearchFormState";
import LocationFilterListComponent from "../../common/location/LocationFilterListComponent";
import HotelSearchCriteria from "../../../states/HotelSearchCriteria";
import DateRangePicker from "../../common/datepicker/DateRangePicker";
import dayjs from 'dayjs';
import '../home/HomePage.css'

interface Attrs { 
    locations : Location[],
    messageProvider: MessageProvider;
    searchCriteria?: HotelSearchCriteria;
    onSearch: (searchCriteria:HotelSearchCriteria) => void;
}

function HotelSearchFormCard(): m.Component<Attrs> {
    let hotelSearchFormState:HotelSearchFormState = new HotelSearchFormState();
    let isShowingLocationSelectionDialog = false;
    let isShowingDateSelectionDialog = false;
    let startYear = dayjs().year();
    let startMonth = dayjs().month() + 1;

    return {
        oninit(vnode) {
            if(vnode.attrs.searchCriteria) {
                let searchCriteria = vnode.attrs.searchCriteria;
                hotelSearchFormState.location = searchCriteria.getLocation();
                hotelSearchFormState.checkInDate = searchCriteria.getCheckInDate();
                hotelSearchFormState.checkOutDate = searchCriteria.getCheckOutDate();
                hotelSearchFormState.guestType = searchCriteria.getGuestType();
                hotelSearchFormState.numberOfRooms = searchCriteria.getNumberOfRooms();
            }
        },

        onupdate(vnode) {
            if(isShowingLocationSelectionDialog || isShowingDateSelectionDialog){
                document.body.style.overflow = "hidden";
            }else{
                document.body.style.overflow = "auto";
            }
        },
        
        view(vnode) {    
            const {locations, messageProvider, onSearch} = vnode.attrs;    
    
            return m("div",{}, [                
                m("div.card shadow-lg rounded-25", 
                    m("div.card-body", 
                        m(SearchFormComponent, {                
                            messageProvider : messageProvider,
                            hotelSearchFormState : hotelSearchFormState,
                            isOnDesktop: true,
                            isOpeningDialog: isShowingDateSelectionDialog || isShowingLocationSelectionDialog,
                            onSearchClick: function(){
                                console.log("Search now", hotelSearchFormState);
                                onSearch(hotelSearchFormState.toHotelSearchCriteria());
                            },
                            onLocationClick: function() {
                                isShowingLocationSelectionDialog = true;
                            },
                            onDateRangePickerClick: function(){
                                isShowingDateSelectionDialog = true;
                            }
                        }) 
                    )
                ),
                
                m(Dialog, {
                    "title": "Select Location",
                    isOnDesktop: true,
                    isOpen: isShowingLocationSelectionDialog,
                    onClose : () => {
                        isShowingLocationSelectionDialog = false;
                    },
                    actionItems : [
                        {
                            label: "Close",
                            onclick: () => {
                                isShowingLocationSelectionDialog = false;
                            }
                        }
                    ],
                    isLocationDialog: true
                }, [
                    m(LocationFilterListComponent, {
                        messageProvider : messageProvider,
                        locations : locations,
                        isShowAttraction: true,
                        onLocationSelected: (location: Location) => {
                            isShowingLocationSelectionDialog = false;
                            hotelSearchFormState.location = location;
                        }
                    })
                ]),

                m(CalendarDialog, {
                    "title": "Select Date",
                    isOnDesktop: true,
                    showCloseIcon: true,
                    isOpen: isShowingDateSelectionDialog,
                    onClose : () => {
                        isShowingDateSelectionDialog = false;
                    },
                }, [
                    m(DateRangePicker, {
                        isOnDesktop: true,
                        startYear: startYear,
                        startMonth: startMonth,
                        selectedDateRange: {
                            startDate: hotelSearchFormState.checkInDate,
                            endDate: hotelSearchFormState.checkOutDate
                        },
                        startLabel: messageProvider.get("checkin_date"),
                        endLabel: messageProvider.get("checkout_date"),
                        applyButtonLabel: messageProvider.get("apply_dates"),
                        minDate: dayjs().format("YYYY-MM-DD"),
                        maxRange: 13,
                        onDateRangeSelected: (startDate, endDate) => {
                            isShowingDateSelectionDialog = false;    
                            hotelSearchFormState.checkInDate = startDate;
                            hotelSearchFormState.checkOutDate = endDate;                     
                        }
                    })
                ])
                
            ])
        }
    }
}

export default HotelSearchFormCard;

